module.exports = __webpack_public_path__ + "media/images/ogp-ea1948dc4568f511895fe802a53623f3.png";